import React from "react";
import "../styles/Transportation.css";

const Transportation = () => {
  return (
    <div className="transportation-container">
      {/* Hero Section */}
      <div className="hero-section">
        <img
          src="/transportation.jpg"
          alt="Gurukul Transport"
          className="hero-image"
        />
        <h1 className="hero-title">Gurukul Transport Services</h1>
      </div>

      {/* About Transportation */}
      <section className="transportation-info">
        <h2>Our Transport Facilities</h2>
        <p>
          We provide **safe and reliable** transport services for our students 
          and staff in **Sawai Choti** and **Sayala**. Our **buses and van taxis** 
          ensure smooth and comfortable travel. We prioritize **safety, punctuality, 
          and convenience** for all our passengers.
        </p>
        <div className="service-list">
          <div className="service-item">
            <img src="/transportation.jpg" alt="Bus Service" />
            <h3>School Bus Service</h3>
            <p>Daily bus services with well-maintained, GPS-enabled buses.</p>
          </div>
          <div className="service-item">
            <img src="/transportation.jpg" alt="Van Taxi Service" />
            <h3>Van Taxi Services</h3>
            <p>Quick and comfortable van taxis for safe student travel.</p>
          </div>
        </div>
      </section>

      {/* Safety Measures */}
      <section className="safety-section">
        <h2>Our Commitment to Safety</h2>
        <ul className="safety-list">
          <li>✔ **Trained and experienced drivers** with verified backgrounds.</li>
          <li>✔ **Speed control monitoring** to ensure safe driving.</li>
          <li>✔ **GPS tracking** in all vehicles for real-time monitoring.</li>
          <li>✔ **First-aid kits** available in every vehicle.</li>
          <li>✔ **Regular vehicle maintenance** to ensure smooth travel.</li>
        </ul>
      </section>

      {/* Parent's Concerns */}
      <section className="parents-concern">
        <h2>Peace of Mind for Parents</h2>
        <p>
          We understand that **parents trust us** with their children's safety. 
          That’s why we provide real-time **bus tracking**, emergency contact numbers, 
          and direct communication with school authorities in case of any issues.
        </p>
        <div className="parent-features">
          <div className="feature">
            <h3>Live GPS Tracking</h3>
            <p>Parents can track their child's location via our mobile app.</p>
          </div>
          <div className="feature">
            <h3>Emergency Contact Support</h3>
            <p>24/7 helpline for any transport-related queries.</p>
          </div>
          <div className="feature">
            <h3>Verified Drivers</h3>
            <p>All drivers undergo police verification and medical checkups.</p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      {/* <section className="contact-section">
        <h2>Need Assistance?</h2>
        <p>For transport-related queries, contact our office.</p>
        <button className="contact-btn">Contact Us</button>
      </section> */}
    </div>
  );
};

export default Transportation;
